import * as React from "react";

import { BREAKPOINT_SMALL } from "../../../config";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  navbarRight: {
    marginRight: 24,
    display: "flex",
    alignItems: "center",
    [`@media(max-width: ${BREAKPOINT_SMALL})`]: {
      marginRight: 0,
    },
  },
}));

interface INavBarRight {
  children: Array<React.ReactElement>;
}

export const NavBarRight = (props: INavBarRight) => {
  const classNames = useStyles();

  return <div className={classNames.navbarRight}>{props.children}</div>;
};
